import { MDBContainer, MDBRow } from "mdb-react-ui-kit"
import { MediaBanner } from './MediaBanner/MediaBanner'
import { MediaContent } from './MediaContent/MediaContent'
import { createContext } from "react"

export const Media = () => {

    return (
        <MDBContainer className={'border border-0 border-danger'}>
            <MDBRow className={'border border-0 border-success mb-5'}>
                <MediaBanner />
            </MDBRow>
            <MDBRow className={'border border-0 border-danger'} >
                <MediaContent />
            </MDBRow>
        </MDBContainer>
    )
}